<template>
  <el-drawer
    title="详情"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="50%"
    withHeader="false"
  >
    <div class="title-box">基本信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动名称">
        <div>{{ info.name }}</div>
        <el-button type="primary" @click="lookActive(info.id)" size="mini" style="margin-left: 10px"
          >预览活动</el-button
        >
      </el-descriptions-item>
      <el-descriptions-item label="小程序/APP链接">
        <div class="url-box">
          <!-- <a :href="info.url" target="_blank" style="color: #409eff">{{ info.url }}</a> -->
          {{ '/pages/promoter/limit-coupon/index?activeId=' + info.id }}
        </div>

        <el-button
          type="primary"
          @click="copyUrl('/pages/promoter/limit-coupon/index?activeId=' + info.id)"
          size="mini"
          style="margin-left: 10px"
          >复制</el-button
        >
      </el-descriptions-item>
      <!-- <el-descriptions-item label="APP链接">
        <div class="url-box">
          <a :href="info.url" target="_blank" style="color: #409eff">{{ info.url }}</a>
        </div>

        <el-button type="primary" @click="copyUrl(info.url)" size="mini" style="margin-left: 10px"
          >复制</el-button
        >
      </el-descriptions-item> -->
      <el-descriptions-item label="隶属公司">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="活动时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
      <el-descriptions-item label="抢购时间" v-if="info.activityTimeList">
        <div v-if="info.activityTimeList.length">
          <div v-for="(item, index) in info.activityTimeList" :key="index">
            {{ item.start }} - {{ item.end }}
          </div>
        </div>
        <div v-else>全天</div>
      </el-descriptions-item>
    </el-descriptions>
    <div class="title-box">乘客端展示</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动头图">
        <el-image
          :src="info.headImgUrl"
          style="width: 120px; margin-left: 30px"
          :preview-src-list="[info.headImgUrl]"
        />
      </el-descriptions-item>
      <el-descriptions-item label="活动背景色">{{ info.backcolor }}</el-descriptions-item>
      <el-descriptions-item label="活动规则">
        <div v-html="info.rule"></div>
      </el-descriptions-item>
    </el-descriptions>
    <div class="title-box">活动奖励</div>
    <el-table
      :data="info.couponInfoList"
      border
      size="mini"
      max-height="280px"
      style="margin: 0 10px"
    >
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column label="优惠券名称" align="center" prop="couponName" />
      <el-table-column label="所属礼包" align="center" prop="giftName" />
      <el-table-column label="金额/个" align="center" prop="discountsMoney" />
      <el-table-column label="每次领取数量" align="center" prop="num" />
      <el-table-column label="每日限量" align="center" prop="dayNum" />
    </el-table>
    <div class="descriptions-text">每人限领 {{ info.everyPersonTime }} 次</div>

    <div class="title-box">其他</div>
    <div class="bottom-box">
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="创建人">{{ info.createUser }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ info.auditUser }}</el-descriptions-item>
        <el-descriptions-item label="活动状态">{{ info.statusTr }}</el-descriptions-item>
        <el-descriptions-item v-if="info.refuseMsg" label="不通过原因">{{
          info.refuseMsg
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1">
        <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ info.auditTime }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
  import { getInfo } from '@/api/marketing/activities-api'
  import { copyText } from '@/util/util'

  export default {
    data() {
      return {
        drawer: false,
        info: {
          url: ''
        },
        rowCenter: {
          'text-align': 'center'
        }
      }
    },
    methods: {
      init(id) {
        this.advertisingId = id
        this.getInfoFetch(id)
      },
      getInfoFetch(id) {
        this.$loading()
        getInfo(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              data.activityTimeList.forEach((item) => {
                item.start = item.start.substr(0, 5)
                item.end = item.end.substr(0, 5)
              })
              this.info = data
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.title = ''
        this.info = {}
        this.drawer = false
      },
      // 复制链接
      async copyUrl(url) {
        await copyText(url)
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      },
      lookActive(id) {
        // 预览活动
        this.$emit('lookActive', id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .bottom-box {
    display: flex;
  }

  .descriptions-text {
    text-align: left;
    font-weight: 400;
    line-height: 1.5;
    font-size: 14px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  .url-box {
    color: #409eff;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ::v-deep .el-descriptions-item__container {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-descriptions-item__container {
    align-items: baseline !important;
  }
</style>
